// extracted by mini-css-extract-plugin
export default {"value-row":"XCpHKZiy_mBm0OpkTGXa","pass":"HI7aPTn6AJtvhY5RdqOm","warning":"ezz_Ge_NLiaSrvfSTs1y","fail":"SIEgfoxVDVcr5pFjohX8"};